export default {
	mounted(el, binding) {
		const options = {
			threshold: binding.arg || 150, // 阈值，默认 100px，到达底部多少像素时触发
			callback: binding.value, // 加载更多数据的回调函数
			isLoading: false, // 是否正在加载中
			throttleDelay: 500, // 节流延迟，单位毫秒
		};

		const onScroll = () => {
			if (options.isLoading) return; // 避免重复加载

			const { scrollHeight, scrollTop, clientHeight } = el;

			// 判断是否滚动到底部
			if (scrollHeight - scrollTop - clientHeight <= options.threshold) {
				options.isLoading = true;

				Promise.resolve(options.callback())
					.then(() => {
						options.isLoading = false; // 加载完成后重置状态
					})
					.catch((error) => {
						options.isLoading = false;
						console.error("加载更多数据时出错:", error); // 处理错误
					});
			}
		};

		// 使用节流函数
		el.addEventListener("scroll", throttle(onScroll, options.throttleDelay));
		el._onScroll = onScroll; // 存储 onScroll 函数，方便在 unmounted 时移除
	},

	unmounted(el) {
		el.removeEventListener("scroll", el._onScroll); // 移除滚动事件监听
	},
};

// 节流函数
function throttle(func, delay) {
	let timeoutId;
	return function (...args) {
		if (!timeoutId) {
			timeoutId = setTimeout(() => {
				func.apply(this, args);
				timeoutId = null;
			}, delay);
		}
	};
}
